import Api from "../config/Axios";
import moment from "moment";
import {TrackerApi} from "../config/Axios";



// Order List
export const getOrderManagementList = (token, user_id) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/tasks", config);
};

export const getOrderManagementSearchList = (token, user_id, data, storeID) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.post(
    "api/web/tasks/store-ids?customerPhone=" +
      (data.phone ? data.phone : "") +
      "&orderId=" +
      (data.order_id ? data.order_id : "") +
      "&unionStatus=" +
      (data.unionStatus ? data.unionStatus : "") +
      "&status=" +
      (data.status ? `${data.status}`:"")+
      "&startDate=" +
      (data.startDate === "" || data.startDate === null? moment().add(5, "hours").toISOString(): moment(data.startDate).add(5, "hours").toISOString())+
      "&endDate=" +
      (data.endDate === "" || data.endDate === null? moment().add(5, "hours").toISOString(): moment(data.endDate).add(5, "hours").toISOString()),
    { storeIds: storeID },
    config
  );
};

// Order Riding tracking Detail
export const getRidingTracking = (beid) => {
  const config = {
    headers: {
      "Authorization":
      "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6Iis5MjMzNjIxMjAxMjEiLCJyaWRlcklkIjoiNjM5Yzg2NmYyZGQ4Yzg3ZTE3ZjkxZjBkIiwiaWF0IjoxNjcyMTI3NTc1LCJleHAiOjE2ODA3Njc1NzV9.vn0GIB8GUVzfAVxf7Ho9R2jyVvTxjv8MegRYAkhCiKM",
      "Content-Type": "application/json",
    },
  };
  return TrackerApi.get(`api/app/rider/get-location?riderId=${beid}`, config);
};


// Single Order Detail
export const getOrderManagementDetail = (beid, token, user_id) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/tasks/${beid}`, config);
};
// Order Status Get eg.Cancel & Complate
export const getOrderDetailStatus = (token, user_id) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/task-statuses`, config);
};
// Order Status Change
export const getOrderDetailStatusMark = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/task/mark-status", data, config);
};

// update task status by orderId
export const getOrderUpdateCancelAndCompleteStatus = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/task/update/orderId", data, config);
};

// update task status by orderId
export const getOrderCancelChargeToRider = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.post("api/web/task/cancel/charge-to-rider", data, config);
};

export const getOrderDetailAssignRider = (data) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      UserId: localStorage.getItem("user_id"),
    },
  };
  return Api.post("api/web/task/assign-rider/request", data, config);
};
// Order Reassign Rider
export const getOrderDetailReassignRider = (data) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      UserId: localStorage.getItem("user_id"),
    },
  };
  return Api.patch("api/web/task/assign-rider", data, config);
};
// Order Unassign Rider
export const getOrderDetailUnassignRider = (data) => {
  // console.log("services data", data)

  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      UserId: localStorage.getItem("user_id"),
    },
  };
  return Api.post("api/web/task/un-assign-rider", data, config);
};
// Order Edit
export const putOrderDetailEdit = (beid, data) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      UserId: localStorage.getItem("user_id"),
    },
  };
  return Api.put(`api/web/task/${beid}`, data, config);
};
// Order Issues List
export const putOrderDetailIssues = (beid, token, user_id) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/task/issue/order/${beid}`, config);
};

// Order Issues Create
export const putOrderDetailCreate = (data) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      UserId: localStorage.getItem("user_id"),
    },
  };
  return Api.post("api/web/task/issue/create", data, config);
};

export const getOrderAssignmentRequests = (beid, token, user_id) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`/api/web/task/latest/assignment-requests`, config);
  // return Api.get(`/api/web/task/latest/assignment-requests${beid}`, config);
};

// Assign Story
export const getOrderAssignStory = (token, user_id, beid) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`/api/web/task/assignment/stories/${beid}`, config);
};

// Assignment Requests
export const getAssignmentRequests = (token, user_id, beid, pagi) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`/api/web/order-assigment-logs?orderId=${beid}&page=${pagi.currentPage}&limit=${pagi.limit}`, config);
};

// Issues Requests
export const getIssuesRequests = (token, user_id, beid, pagi) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`/api/web/issue/by-order/${beid}?page=${pagi.currentPage}&limit=${pagi.limit}`, config);
};

// list rider for force completed status
export const getOrderForceCompletedStatus = (token, user_id, beid) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`/api/web/rider-list-available-only/${beid}`, config);
};

// Order List new
export const getOrderManagementnew = (token, user_id, data) => {
  // console.log("data", data)
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/tasks/order-management?page="+(data?.currentPage||1 )+
  "&limit="+(data?.limit||10 )+
  // "&startDate="+(data.startDate === "" || data.startDate === null? moment().add(5, "hours").toISOString(): moment(data.startDate).add(5, "hours").toISOString())+
  // "&endDate="+(data.endDate === "" || data.endDate === null? moment().add(5, "hours").toISOString(): moment(data.endDate).add(5, "hours").toISOString())+
  "&startDate="+(data.startDate === "" || data.startDate === null? moment().toISOString(): moment(data.startDate).toISOString())+
  "&endDate="+(data.endDate === "" || data.endDate === null? moment().toISOString(): moment(data.endDate).toISOString())+
  "&store_id="+(data.storeIds ? data.storeIds:"" )+
  "&status="+(data.status ? data.status:"" )+
  "&orderId="+(data.order_id ? data.order_id:"" )+
  "&customerPhone="+(data.phone ? data.phone:"" )+
  "&rider_filter="+(data.rider ? data.rider:"" )+
  "&packed_time_exist="+(data.packed_time_exist ? data.packed_time_exist:"" )+
  "&rider_id="+(data.rider_id ? data.rider_id:"" )+
  "&sort="+(data?.sort || "")+
  "&urgent_delivery="+(data?.urgent_delivery || "")+
  "&return_pickup="+(data?.return_pickup || "")
  , config)
};

export const patchorderDispactherNote = (token, user_id, beid, data) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch(`/api/web/order/dispatch-notes/${beid}`,data, config);
};

export const postReturnPickupOrders = (token, user_id, beid, data) => {
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  // console.log("Service", config, beid, data)
  return Api.post(`/api/web/task/return-replace/${beid}`,data, config);
};

// export const UpdateCancelOrderReturnLockService = (data) => {
export const UpdateCancelOrderReturnLockService = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch(`api/web/task/canceled-return-status-lock/${data.order_id}`, data, config);
};